import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

/**
 * Colour for a switch that represents an account's live/blocked state — green when
 * the account is usable, red when it is not (TR-26 item 4).
 *
 * Two variants because one of these switches is inverted: on the reseller edit
 * dialog the control is labelled "Block Store", so `checked` means BLOCKED. Using
 * STATUS_SWITCH there would paint blocked green, which is worse than no colour at
 * all — use STATUS_SWITCH_INVERTED whenever checked means "blocked/inactive".
 */
export const STATUS_SWITCH =
  "data-[state=checked]:bg-green-500 data-[state=unchecked]:bg-red-500";

export const STATUS_SWITCH_INVERTED =
  "data-[state=checked]:bg-red-500 data-[state=unchecked]:bg-green-500";

export { Switch }
